module.exports = __webpack_public_path__ + "static/media/5_1.105646d7.jpg";